module.exports = ".dropdown-toggle:empty::after {\n  display: none !important;\n  margin-left: 0.255em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/configurar-creditos/configurar-creditos.component.scss
// module id = ./src/app/administracion/configurar-creditos/configurar-creditos.component.scss
// module chunks = main